import React, { useEffect, useState } from "react";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import { History } from "lucide-react";
import api from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { eaParams, useEa } from "./EaContext";
import { EaChartCard, EaSeg } from "./EaUi";
import { MONTHS_IT } from "./eaFormat";

const PALETTE = ["#94A3B8", "#64748B", "#A855F7", "#0EA5E9", "#10B981", "#F43F5E"];
const axis = { tick: { fontSize: 11, fill: "#64748B" }, axisLine: false, tickLine: false };

// Confronto pluriennale: tutti gli anni disponibili sovrapposti mese per mese.
export function EaMultiYearCard({ commodity, metrics, codes, color, testid }) {
  const { filters } = useEa();
  const [on, setOn] = useState(false);
  const [metric, setMetric] = useState(metrics[0].key);
  const [d, setD] = useState(null);
  useEffect(() => {
    if (!on) return;
    api.get("/ea/history", { params: eaParams(filters, { codes, commodity, metric }) }).then((r) => setD(r.data)).catch(() => setD(null));
  }, [on, metric, codes, filters.company]); // eslint-disable-line react-hooks/exhaustive-deps
  const m = metrics.find((x) => x.key === metric);
  const years = d?.years || [];
  const data = MONTHS_IT.map((label, i) => Object.fromEntries([["label", label], ...years.map((y) => [y.year, y.monthly[i] != null ? m.conv(y.monthly[i]) : null])]));
  const cur = Number(filters.year) || years[years.length - 1]?.year;
  return (
    <EaChartCard title="Confronto pluriennale" subtitle="Tutti gli anni disponibili sovrapposti, per vedere il trend storico" testid={testid}
      right={<div className="flex items-center gap-3 flex-wrap">
        {on && metrics.length > 1 && <EaSeg value={metric} onChange={setMetric} options={metrics.map((x) => [x.key, x.label])} testid={`${testid}-metric`} />}
        <label className="inline-flex items-center gap-2 text-xs text-slate-600"><History size={14} /> Più anni<Switch checked={on} onCheckedChange={setOn} data-testid={`${testid}-toggle`} /></label>
      </div>}>
      {on && (
        <div className="h-72">
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={data}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" />
              <XAxis dataKey="label" {...axis} /><YAxis {...axis} width={80} tickFormatter={(v) => m.fmt(v, true)} />
              <Tooltip formatter={(v, n) => [m.fmt(v), n]} /><Legend wrapperStyle={{ fontSize: 12 }} />
              {years.map((y, i) => <Line key={y.year} dataKey={y.year} name={String(y.year)} stroke={y.year === cur ? color : PALETTE[i % PALETTE.length]} strokeWidth={y.year === cur ? 3 : 1.8} dot={{ r: 2 }} connectNulls={false} />)}
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </EaChartCard>
  );
}
